import validator from 'validator';

/**
 * Defines a single rule for validating a field. A field can have many rules.
 * You can use this class directly, but it may be easier to use the generic enums in ValidationType.
 */
export default class ValidationRule {
	/**
	 * options may contain the following options:
	 * 		validationType: use ValidationRules... constants (note that ValidationRules.CUSTOM is an option)
	 * 		[option]: see validator documentation for parameter details; this is for passing in extra parameters for the validator (like a date for isAfter)
	 * 		errorMessage: error message to show if this rule fails
	 * 		customValidationMethod: pass in your own callback function to call for validation
	 *
	 * @param options the options for setting up a validation rule
	 */
	constructor({ruleType, isValid, validatorFunc, errorMessage, args, ...rest}) {
		this.options = {
			ruleType: ruleType,
			isValid: isValid,
			validatorFunc: validatorFunc,
			errorMessage: errorMessage,
			args: args,
		};

		if (0 !== Object.keys(rest).length) {
			console.error('Extra parameters passed to ValidationRule constructor: ' . Object.keys(rest).join(','));
		}
		if (!this.options.ruleType) {
			console.error('ValidationRule requires a ruleType so that it knows what type of rule it is');
		}
		if (!this.options.isValid && !this.options.validatorFunc) {
			console.error('ValidationRule requires either an isValid function or a validatorFunc', this.options);
		}
		if (!this.options.errorMessage) {
			console.error('ValidationRule requires an errorMessage function', this.options);
		}

		this.ruleType = ruleType;
	}

	/**
	 * is the piece of data valid for this rule
	 *
	 * @param data converted to a string
	 * @param formData all the data items, for complex rules that depend on other data elements
	 * @return true if valid
	 */
	isValid(data, formData) {
		// make sure data is a string since validator library only takes strings
		const useData = this.stringData(data);

		// if isValid is not null then a custom callback is given, otherwise use validator library function
		return this.options.isValid ?
			this.options.isValid(useData, formData) :
			validator[this.options.validatorFunc].apply(this, ([useData].concat(this.options.args)));
	}

	stringData(data) {
		return typeof data === 'string' ? data : ('' + (data ? data : ''));
	}

	/**
	 * generate an error message about why this rule failed
	 *
	 * @param data the data that didn't pass
	 * @return string describing what is wrong
	 */
	errorMessage(data) {
		return this.options.errorMessage(this.stringData(data));
	}
}
